<template>
  <div class="container">
    <div class="NotFound shadow">
      <center>
        <h2>{{ contenido }}</h2>
        <button
          @click="$router.push('/inicio')"
          type="button"
          class="btn btn_modal btn-md mt-5 mb-5 shadow"
        >
          VOLVER AL INICIO
        </button>
      </center>
    </div>
  </div>
</template>

<script>
// CONTROLADOR
export default {
  name: "NotFound",
  data() {
    return {
      contenido: "[ 404 - Página No Encontrada ]",
    };
  },
  created() {},
};
</script>

<style scoped>
/* CUANDO ESTÁ EN PC */
.NotFound {
  background-color: rgba(255, 255, 255, 0.8);
  margin-top: 12%;
  padding: 5px;
  border-radius: 20px;
}
/* CUANDO ESTÁ EN MÓVIL */
@media screen and (max-width: 767px) {
  .NotFound {
    margin-top: 30%;
  }
}
</style>